import { useTranslation } from "react-i18next";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
const Notification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-full p-8">
      <div className="flex items-center" onClick={() => navigate(-1)}>
        <IoArrowBackOutline
          color="#2379be"
          className="hover:cursor-pointer mr-4"
          size={20}
        />
        <h2 className="border-l-4 pl-4 border-yellow-400 font-bold">
          {t(`my.notification`)}
        </h2>
      </div>
      <div className="flex p-5 bg-white mt-5 h-full justify-center items-center">
        <div>{t("empty.notification")}</div>
      </div>
    </div>
  );
};

export default Notification;
